import { isHtmlElement } from "./closest-data-sit-attribute";

export function closestElement<T extends HTMLElement>(
  composedPath: EventTarget[],
  selector: string,
) {
  return composedPath
    .filter(isHtmlElement)
    .find((element) => element.matches(selector)) as T | undefined;
}
